import { ClaireApp } from "@clairejs/core";

export class ClaireClient extends ClaireApp {}
